<template>
  <div class="page">
    <!-- 广告图 -->
    <Banner />
    <!-- 我们的优势 -->
    <Lead />
    <!-- 企业介绍 -->
    <Present />
    <!-- 合作伙伴 -->
    <Partner />
    <!-- 联系我们 -->
    <Contact />
  </div>
</template>

<script>
import Banner from './components/banner.vue'
import Lead from './components/lead.vue'
import Present from './components/present.vue'
import Partner from './components/partner.vue'
import Contact from './components/contact.vue'
export default {
  components: {
    Banner,
    Lead,
    Present,
    Partner,
    Contact
  },
  created() {
    console.log('关于我们')
  }
}
</script>

<style lang="scss" scoped></style>
